import React from 'react'

import {
  MdListAlt,
  MdViewWeek,
  MdChangeCircle,
  MdFilterList,
  MdAccountCircle,
} from 'react-icons/md'
import {
  Routes,
  Route,
  NavLink,
  Navigate,
} from 'react-router-dom'
import styled, { useTheme } from 'styled-components'

import { useRoles } from '@hooks/roles'
import { useSiteFeatures } from '@hooks/siteFeatures'
import { FiltersView } from '@screens/Main/Filters'
import { Profile } from '@screens/Main/Profile'
import { Todo } from '@screens/Main/Todo'
import { WeekView } from '@screens/Main/WeekView'

const Layout = styled.div`
  display: flex;
  flex-direction: column;
  height: calc(100dvh + (env(safe-area-inset-bottom)/2));
  width: 100%; 
`

const Content = styled.div`
  flex: 1;
  min-height: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column; 
`

const TabBar = styled.nav`
  display: flex;
  min-height: 60px;  
  background-color: ${({ theme }) => theme.colors.tabBarBackground};
  padding-bottom: 10px;
  border-top: none;
`

const TabItem = styled(NavLink)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  color: ${({ theme }) => theme.colors.tabBarInactive};
  font-size: 14px;
  text-decoration: none;
  gap: 2px;

  &.active {
    color: ${({ theme }) => theme.colors.tabBarActive};
  }
`

const TabLabel = styled.span`
  font-size: 12px;
`

export function HomeTabs() {
  const theme = useTheme()
  const { isMidstreamProcess } = useSiteFeatures()
  const { isUserAllowed, mechanicalRoles, readOnlyUserRoles } = useRoles()
  const canAccessMechanical = isUserAllowed([...mechanicalRoles, ...readOnlyUserRoles])
  const canAccessProcess = canAccessMechanical

  const defaultRoute = isMidstreamProcess
    ? '/todo'
    : isUserAllowed(['process'])
      ? '/process'
      : canAccessMechanical
        ? '/mechanical'
        : canAccessProcess
          ? '/process'
          : '/filters'

  return (
    <Layout>
      <Content>
        <Routes>
          {isMidstreamProcess ? (
            <>
              <Route path="/todo" element={<Todo />} />
              <Route path="/week-view" element={<WeekView />} />
            </>
          ) : (
            <>
              {canAccessMechanical && (
                <Route path="/mechanical" element={<WeekView />} />
              )}
              {canAccessProcess && (
                <Route path="/process" element={<WeekView />} />
              )}
            </>
          )}
          <Route path="/filters" element={<FiltersView />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/" element={<Navigate to={defaultRoute} replace />} />
        </Routes>
      </Content>

      <TabBar>
        {isMidstreamProcess ? (
          <>
            <TabItem to="/todo">
              <MdListAlt size={24} />
              <TabLabel>Todo</TabLabel>
            </TabItem>
            <TabItem to="/week-view">
              <MdViewWeek size={24} />
              <TabLabel>Week View</TabLabel>
            </TabItem>
          </>
        ) : (
          <>
            {canAccessMechanical && (
              <TabItem to="/mechanical">
                <MdViewWeek size={24} />
                <TabLabel>Mechanical</TabLabel>
              </TabItem>
            )}
            {canAccessProcess && (
              <TabItem to="/process">
                <MdChangeCircle size={24} />
                <TabLabel>Process</TabLabel>
              </TabItem>
            )}
          </>
        )}
        <TabItem to="/filters">
          <MdFilterList size={24} />
          <TabLabel>Filters</TabLabel>
        </TabItem>
        <TabItem to="/profile">
          <MdAccountCircle size={24} />
          <TabLabel>Profile</TabLabel>
        </TabItem>
      </TabBar>
    </Layout>
  )
}
